import { MenuNodeType } from "components/Menu/model";
import { getHomepageLinkForLanguage, Language } from "utils/language";

export const isJapaneseLanguageSetPage = (
  pathname: string,
  languageNodes: MenuNodeType.Link[]
) => getHomepageLinkForLanguage(languageNodes, Language.JAPANESE) === pathname;
